const translationsEn = {
    light: 'Light',
    dark: 'Dark',
    theme: 'Theme:',
    ro: 'Romanian',
    en: 'English',
    language: 'Language:',
    country: 'Country:',
    RO: 'Romania',
    reset: 'Reset Settings',
    open: 'Open',
    selectDomain: 'Select a domain:',
    exportExcel: 'Export Excel',
    domain: 'Domain',
    user: 'User',
    timestamp: 'Date',
    action: 'Action',
    applicationload: 'Application Load',
    applicationclosed: 'Application Closed',
    lockerselected: 'Easybox Selected',
    lockerfavourite: 'Favourite Easybox',
    to: 'To',
    from: 'From',
    noResults: 'No results',
    hello: 'Hello',
    clients: 'Clients',
    addClient: 'Add Client',
    search: 'Search',
    favouriteLockerEnabled: 'Favourite locker enabled',
    hosts: 'Hosts',
    hostAdded: 'The new host was added!',
    hostRemoved: 'The host was removed!',
    favLockerChanged: `Option 'FavouriteLockerEnabled' was changed!`,
    client: 'Client',
    allowedHosts: 'Allowed hosts:',
    addHostButton: 'Add domain',
    deleteClient: 'Delete client',
    areYouSure: 'Are you sure you want to delete the client?',
    clientDeleted: 'Client was deleted!',
    fetchError: 'There was an error!',
    getClientError: 'There was an error getting the client! Please try again!',
    getClientsError: 'There was an error getting the clients! Please try again!',
    addClientError: 'There was an error adding the client! Please try again!',
    editClientError: 'There was an error editing the client! Please try again!',
    getActionsReportError: 'There was an error getting the report! Please try again!',
    deleteClientError: 'There was an error deleting the client! Please try again!',
    duplicateHostError: 'Duplicate hosts are not allowed! Please try with another host!',
    invalidHostError: 'Invalid host! Please try again!',
    clientIdError: 'Client Id is invalid! Please try again!',
    getHostsError: 'There was an error getting the hosts! Please try again!',
    badRequestError: 'Bad request detected. Please try again!',
    notFoundError: 'Requested data was not found. Please try again!',
    internalServerError: 'Something was wrong. Please try again!',
    historyUserAddedClient: 'added the client.',
    userHistoryTableTitle: 'User',
    actionHistoryTableTitle: 'Changes',
    viewHistory: 'Change history',
    noHistoryFound: 'There is no history for this client',
    getHistoryError: 'There was an error loading the history for the client. Please try again!',
    cui: 'CUI',
    createdAt: 'Created at',
    saveCui: 'Save CUI',
    cuiSaved: 'The CUI was updated!',
} as const;

export default translationsEn;
